import Module from '../lib/module';

export default class CollapsibleNavigation extends Module {
  private controlsSelector: string;

  setup() {
    this.controlsSelector = this.element.getAttribute('data-control-selector');

    this.bind();
  }

  private bind() {
    this.queryControls().forEach((control) => {
      control.addEventListener('click', (event) => {
        if (this.element.classList.contains('is-visible')) {
          this.element.classList.remove('is-visible');
          this.queryControls().forEach(function(_control) { _control.classList.remove('is-active'); });
        } else {
          this.element.classList.add('is-visible');
          this.queryControls().forEach(function(_control) { _control.classList.add('is-active'); });
        }
      });
    });
  }

  private queryControls() {
    return Array.from(document.querySelectorAll(this.controlsSelector));
  }
}
